import { ApiModel } from './api.model';

export abstract class CrudModel<Model> extends ApiModel<Model> {
    constructor(public save: (object?: Model | Model[]) => Promise<Model[] | Model>, input?: Object) {
        super(input);
    }
}
